<template>
  <div>
    <modalWindow
      v-if="passwordModal"
      @close="passwordModal = false;$store.state.openPassword = false;"
      width="450"
    >
      <div class="titlebar">Wachtwoord wijzigen</div>
      <span v-if="msg.msg" :class="['form-' + msg.type]" v-html="msg.msg" />
      <form @submit.prevent id="passwordForm" class="inset">
        <input type=password ref="password" placeholder="Oude wachtwoord">
        <input type=password ref="newpassword" placeholder="Nieuwe wachtwoord">
        <input type=password ref="newpassword2" placeholder="Nogmaals nieuwe wachtwoord">
        <input type=submit @click="changePassword" value="Wachtwoord wijzigen">
      </form>
    </modalWindow>

    <modalWindow
      v-if="twoFactorModal"
      @close="twoFactorModal = false;$store.state.openTwofactor = false;"
      width="450"
    >
      <div class="titlebar">
        Twee staps verificatie
        {{ $store.state.twoFactor ? 'verwijderen' : 'activeren' }}
      </div>
      <span v-if="msg.msg" :class="['form-' + msg.type]" v-html="msg.msg" />
      <form v-if="!$store.state.twoFactor" id="twoFactorForm" @submit.prevent class="inset">
        Hoe wilt u uw tweestaps verificatie activeren?
        <br />
        <input
          type=radio
          name="type"
          v-model="two_factor_type"
          value="qr"
          id="two_qr"
          @click="
            msg.msg = `Scan de QR-code met de authenticatie app van Microsoft of Google en vul de
            autorisatie code in`;
            msg.type = 'notice'
          "
          style="width: 30px"
        >
        <label for="two_qr">
          <awesomeIcon icon="mobile-alt" /> Via authenticatie app
        </label>
        <input
          type=radio
          name="type"
          v-model="two_factor_type"
          value="email"
          id="two_email"
          @click="
            msg.msg = 'Verstuur de email en kopieer hieruit de autorisatie code';
            msg.type = 'notice'
          "
          style="width: 30px;margin-left: 20px;"
        >
        <label for="two_email">
          <awesomeIcon icon="envelope" /> Via email
        </label>
        <br /><br />
        <span v-if="two_factor_type === 'qr'">
          <b>Scan de QR-code</b> met de verificatie-app op uw mobiele telefoon:
        </span>
        <div v-if="two_factor_type == 'qr'" class="row" style="text-align: center">
          <vue-qrious
            :value="qr"
            :size="200" background="transparent" class="qrcode"
          />
        </div>
        <input
          v-else
          type=submit
          @click="mail2fa"
          value="Stuur mij een autorisatie code per email"
          style="margin-bottom: 10px"
        >
        <span>
          {{
            two_factor_type === 'qr'
              ? `Vul hieronder de ontvangen autorisatie code in van uw
                verificatie-app op uw mobiele telefoon:`
              : 'Vul hieronder de toegestuurde autorisatie code vanuit uw email in:'
          }}
        </span>
        <input type=text ref="token" placeholder="Autorisatie code">
        <input type=submit @click="activate2fa" value="Activeren">
      </form>
      <form v-else @submit.prevent class="inset">
        <b>Weet u zeker dat u de tweestaps verificatie wilt verwijderen?</b>
        <input type=submit @click="disableTwoFactor" value="Twee staps verificatie verwijderen">
      </form>
    </modalWindow>

  </div>
</template>

<script>
import VueQrious from 'vue-qrious';

export default {
  name: 'PasswordAndSecurity',
  components: {
    VueQrious,
  },
  data() {
    return {
      details: {},
      msg: { msg: null, type: 'notice' },
      passwordModal: false,
      twoFactorModal: false,
      two_factor_type: 'qr',
      qr: null,
      key: null,
    };
  },
  computed: {
    openTwoFactor() {
      return this.$store.state.openTwofactor;
    },
    openPassword() {
      return this.$store.state.openPassword;
    },
  },
  watch: {
    openTwoFactor() {
      this.passwordModal = false;
      if (this.$store.state.openTwofactor) {
        this.getTwoFactor();
        this.twoFactorModal = true;
        if (!this.$store.state.twoFactor) {
          this.msg = {
            msg: this.two_factor_type === 'qr'
              ? 'Scan de QR-code met de authenticatie app van Microsoft of Google en vul de autorisatie code in'
              : 'Verstuur de email en kopieer hieruit de autorisatie code',
            type: 'notice',
          };
        }
      }
    },
    openPassword() {
      this.twoFactorModal = false;
      this.passwordModal = true;
      this.msg = {
        msg: `
          Uw wachtwoord dient te bestaan uit ten minste 12 karakters. <br /> Tip: gebruik
          een zin die u makkelijk onthoudt of een wachtwoord generator.
        `,
        type: 'notice',
      };
    },
  },
  created() {
    this.sdk.get2fa(
      (response) => {
        if (response.status === 200) {
          this.qr = response.data.uri;
          this.key = response.data.formattedKey;
          this.$store.state.twoFactor = false;
        } else {
          this.$store.state.twoFactor = true;
        }
      },
    );
  },
  methods: {
    changePassword() {
      this.twoFactorModal = false;
      if (this.$refs.newpassword.value !== this.$refs.newpassword2.value) {
        this.msg = { msg: 'Nieuwe wachtwoorden niet gelijk!', type: 'error' };
      } else if (this.$refs.newpassword.value.length < 12) {
        this.msg = {
          msg: 'Uw wachtwoord dient te bestaan uit ten minste 12 karakters. Tip: gebruik een zin die u makkelijk onthoudt of een wachtwoord generator.',
          type: 'error',
        };
      } else {
        this.sdk.changePassword(
          this.$refs.password.value,
          this.$refs.newpassword.value,
          (response) => {
            if (response.status === 200) {
              document.getElementById('passwordForm').reset();
              this.msg = {};
              this.$store.state.openPassword = false;
              this.$store.state.confirm.toggle({
                alert: true,
                title: 'Wachtwoord aangepast',
                text: 'Wachtwoord aangepast!',
                cb: () => {},
              });
            } else {
              this.msg = { msg: 'Onjuist oud wachtwoord!', type: 'error' };
            }
          },
        );
      }
    },
    getTwoFactor() {
      this.passwordModal = false;
      this.msg = {};
    },
    disableTwoFactor() {
      this.passwordModal = false;
      this.sdk.remove2fa(
        () => {
          this.$store.state.twoFactor = false;
          this.$store.state.openTwofactor = false;
          this.getTwoFactor();
          this.sdk.get2fa(
            (response) => {
              if (response.status === 200) {
                this.qr = response.data.uri;
                this.key = response.data.formattedKey;
              }
            },
          );
          this.msg = {};
          this.eraseCookie('vmvb_2fa');
          this.$store.state.confirm.toggle({
            alert: true,
            title: 'Twee staps verificatie is verwijderd',
            text: 'Uw twee staps verificatie is verwijderd!',
            cb: () => {},
          });
        },
      );
    },
    activate2fa() {
      this.passwordModal = false;
      this.sdk.set2fa(
        this.key,
        this.$refs.token.value,
        this.two_factor_type === 'email' ? 2 : 1,
        (response) => {
          if (response.status === 200) {
            document.getElementById('twoFactorForm').reset();
            this.$store.state.twoFactor = true;
            this.$store.state.openTwofactor = false;
            this.createCookie('vmvb_2fa', 1, 100000);
            this.getTwoFactor();
            this.msg = {};
            this.$store.state.confirm.toggle({
              alert: true,
              title: 'Twee staps verificatie is geactiveerd',
              text: 'Uw twee staps verificatie is geactiveerd!',
              cb: () => {},
            });
          } else {
            this.msg = { msg: 'Autorisatie code niet goed!', type: 'error' };
          }
        },
      );
    },
    mail2fa() {
      this.passwordModal = false;
      this.sdk.email2fa(
        this.key,
        (response) => {
          if (response.status === 200) {
            this.msg = {
              msg: 'Wij hebben u een autorisatie code gestuurd! Kopieer de code en activeer uw twee staps verificatie.',
              type: 'success',
            };
          }
        },
      );
    },
  },
};
</script>
